import React, { useContext, useEffect } from 'react';
import useQueryParams from 'hooks/useQueryParams';
import { Navigate, useNavigate } from 'react-router-dom';
import AuthContext from 'providers/Auth/Auth.context';
import { BUSINESS_ROUTE, LOGIN_ROUTE } from 'data/global';
import { getDataRoomRoute } from 'utils';

import './SocialLogin.styles.scss';
import './SocialLogin.styles.responsive.scss';

const SocialLogin: React.FC = () => {
  const {
    params: { token, refreshToken, dataRoomId },
  } = useQueryParams<{
    token: string;
    refreshToken: string;
    dataRoomId?: string;
  }>();

  const { socialLogin } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token || !refreshToken) return;

    const parsedToken = token.split('#')[0]; // try to eliminate #
    const parsedRefreshToken = refreshToken.split('#')[0]; // try to eliminate #

    socialLogin({
      token: parsedToken,
      refreshToken: parsedRefreshToken,
    });

    navigate(dataRoomId ? getDataRoomRoute(dataRoomId) : BUSINESS_ROUTE);
  }, [token, refreshToken, dataRoomId, socialLogin, navigate]);

  if (!token || !refreshToken)
    return (
      <>
        <Navigate to={LOGIN_ROUTE} replace />
      </>
    );

  return null;
};

export default SocialLogin;
